<template>
  <div>
    <div class="step-indicator">
      Step {{ currentStep + 1 }} of {{ steps.length }}
    </div>
    <ul>
      <li v-for="(step, index) in steps" :key="step.label" :class="listClass(index)" @click="toStep(index)">
        <v-icon class="circle-icon">lens</v-icon>
        {{ step.label }}
        <span><v-icon class="check-icon">check</v-icon></span>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'CreateListingProgressMenu',
    props: {
      steps: {
        type: Array,
        required: true
      }
    },
    computed: {
      currentStep() {
        return this.$store.state.newAuctionStorage.currentStep || 0
      }
    },
    methods: {
      listClass(step) {
        return {
          done: this.currentStep > step,
          active: this.currentStep === step,
          notdone: this.currentStep < step
        }
      },
      toStep(step) {
        if (this.currentStep > step) {
          this.$store.state.newAuctionStorage.currentStep = step
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../pfx.scss';

  .step-indicator {
    font-size: 0.7rem;
    padding-bottom: 1rem;
  }
  li {
    margin-bottom: 0.7rem !important;
    padding: 0;
    span {
      display: none;
    }
    .circle-icon {
      font-size: 0.75em;
      margin-right: 0.5em;
      color: #d8d8d8;
    }
    .check-icon {
      color: #999;
      font-size: 1em;
      font-weight: 600;
    }
  }
  li.done {
    cursor: pointer;
    color: #999;
    span {
      display: inline;
    }
  }
  li.active {
    cursor: not-allowed;
    font-weight: 600;
    .circle-icon {
      color: $color-pfx-brand;
    }
  }
  li.notdone {
    cursor: not-allowed;
  }
</style>



// WEBPACK FOOTER //
// src/components/CreateListingProgressMenu.vue